import { create } from "zustand";
import {
  IReferenceCode,
  ReferenceList,
} from "@/lib/interfaces and Enums/ENUMReferenceList";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";

// LQC-2925 - the GET /ReferenceData code lists, one entry per list so each loads and
// fails on its own. A ticket falls back to its mirrored list until its entry is Loaded.

export interface IReferenceListEntry {
  items: IReferenceCode[];
  status: ReferenceDataStatus;
  error: string;
}

type State = {
  lists: Partial<Record<ReferenceList, IReferenceListEntry>>;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setReferenceListItems: (list: ReferenceList, items: IReferenceCode[]) => void;
  // eslint-disable-next-line no-unused-vars
  setReferenceListStatus: (list: ReferenceList, status: ReferenceDataStatus) => void;
  // eslint-disable-next-line no-unused-vars
  setReferenceListError: (list: ReferenceList, message: string) => void;
  clearReferenceLists: () => void;
};

const EMPTY_ENTRY: IReferenceListEntry = {
  items: [],
  status: ReferenceDataStatus.Idle,
  error: "",
};

export function returnReferenceListEntry(
  lists: State["lists"],
  list: ReferenceList,
): IReferenceListEntry {
  return lists[list] ?? EMPTY_ENTRY;
}

const referenceListsStore = create<State & Action>((set) => ({
  lists: {},

  setReferenceListItems: (list, items) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: { items, status: ReferenceDataStatus.Loaded, error: "" },
      },
    })),
  setReferenceListStatus: (list, status) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: { ...returnReferenceListEntry(state.lists, list), status },
      },
    })),
  // Keeps any items already loaded: a failed reload should not blank a working list.
  setReferenceListError: (list, error) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: {
          ...returnReferenceListEntry(state.lists, list),
          status: ReferenceDataStatus.Error,
          error,
        },
      },
    })),
  clearReferenceLists: () => set({ lists: {} }),
}));

export default referenceListsStore;
